module.exports = __webpack_public_path__ + "img/spinner1.238c7698.gif";